import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'
import { productMainVersionDataSchema } from './product-main-version-data'

/**
 * 產品主類目 - 單筆資料 Schema
 */
export const productMainDataSchema = z.object({
  /** 文案編輯者(真實姓名) */
  copyWriter: z.string().nullable(),
  /** 文案（中） */
  copyWritingEn: z.string().nullable(),
  /** 文案（英） */
  copyWritingZh: z.string(),
  /** 文案編輯日期 */
  copyWriteDate: z.string(),
  /** 是否上架 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 異動者 */
  modifyUser: z.string(),
  /** 異動日期 */
  modifyDate: z.string(),
  /** 主目録名稱（英） */
  nameEn: z.string(),
  /** 主目録名稱（中） */
  nameZh: z.string(),
  /** 主類目代碼 */
  pmCode: z.string(),
  /** ID */
  pmID: z.number(),
  /** 產品Logo圖檔 */
  productLogo: z.string().nullable(),
  /** 產品版本 */
  version: z.array(productMainVersionDataSchema),
  /** 產品簡述（中） */
  descriptionZh: z.string().nullable(),
  /** 產品簡述（英） */
  descriptionEn: z.string().nullable(),
  /** 可視角色 */
  role: z.array(z.string()),
  /** 排序 */
  sort: z.union([z.number(), z.literal('')])
})

/**
 * 產品主類目 - 單筆資料
 */
export interface ProductMainData
  extends z.infer<typeof productMainDataSchema> {}
